import global from "../global.js";
import ConfirmationArea from "./ConfirmationArea.js";
import InputTextArea from "./InputTextArea.js";
import LegalArea from "./LegalArea.js";
import RoomListArea from "./RoomListArea.js";
import StatusArea from "./StatusArea.js";
import {escape_html} from "../utils/Escape.js";

import {LOCAL_CHANNEL_NUMBER} from "../storage/constants.js";

const log = global.log.getLogger("f_mtac.ui.RoomArea");
log.setLevel(log.levels.WARN);

let RoomArea = function () {
    let refreshSelection = () => {
        $("#room_area .mission-item.selected").removeClass("selected");
        $("#room_area .mission-options").hide();
        let selected_space = global.storage.selected_space;
        if (selected_space) {
            $("#room_area .mission-item").eq(selected_space.index).addClass("selected");
            $("#room_area .mission-item").eq(selected_space.index).find(".mission-options").show();
            $("#room_area button[data-method='close']").removeAttr("disabled");
        } else {
            $("#room_area button[data-method='close']").attr("disabled", true);
        }
    };

    this.refreshSpace = async (space_index) => {
        refreshSpaceStatus(space_index);
    };

    let refreshSpaceStatus = async (space_index) => {
        let $space_btn = $("#room_area button.space[data-space-index='" + space_index + "']");
        let space = await global.storage.open_space({space_index});
        const space_is_empty = (await space.is_empty()) ? true : null;
        const space_is_shared = global.storage.shared() ? true : null;
        $("#room_area .mission-item").eq(space_index).find("[data-method='rename']").attr("disabled", space_is_shared);
        $("#room_area .mission-item")
            .eq(space_index)
            .find("[data-method='duplicate']")
            .attr("disabled", space_is_empty || space_is_shared);
        $("#room_area .mission-item")
            .eq(space_index)
            .find("[data-method='erase']")
            .attr("disabled", space_is_empty || space_is_shared);
        if (space_is_empty && (space.name === "" || space.name === global.internationalization.text("global.Without-name"))) {
            // AGPOC-3481 : if space name not empty, display space name and creation date
            $space_btn.html(global.internationalization.text("archive.Empty"));
        } else {
            let space_name = space.name || global.internationalization.text("global.Without-name"); // if falsy!
            // let space_created = new Date(space.created); // Removed until it is implemented correctly
            // let space_modified = new Date(space.modified); // Removed until it is implemented correctly (see story AGPOC-6856)
            $space_btn.html(
                `<span>${escape_html(space_name)}</span>`
                // <h6>${global.internationalization.text("archive.Created")} ${global.internationalization.formatDate(space_created)} ${global.internationalization.formatTime(space_created)}</h6>`
            );
        }
    };
    let refreshAllSpaceStatus = () => {
        $("#room_area button.space").each(async function () {
            refreshSpaceStatus($(this).data("space-index"));
        });
    };
    let interaction_end = () => {
        $("#room_area").hide();
        $("body").off("click.room_area.btn", "#room_area .btn");
    };
    this.interact = async () => {
        refreshAllSpaceStatus();
        refreshSelection();
        $("#room_area").show();
        $("#splash").hide();
        return new Promise((resolve) => {
            let handlers = {
                open: async ($btn) => {
                    if (global.storage.shared()) {
                        // Ask confirmation to leave sharing before switching to another space
                        let confirmation = await ConfirmationArea.interact({
                            title: global.internationalization.text("global.Warning"),
                            tip1: global.internationalization.text("collaboration.Stop-ongoing-sharing"),
                            tip2: ""
                        });
                        if (!confirmation) {
                            return;
                        }
                        StatusArea.disconnect();
                    }
                    var space_index = $btn.data("space-index");
                    if (space_index === undefined) {
                        interaction_end();
                        resolve();
                        return;
                    }
                    await global.storage.open({space_index});
                    refreshSelection();
                    refreshSpaceStatus(space_index);
                    resolve(space_index);
                },
                export: () => {
                    throw "not implemented";
                },
                rename: () => {
                    var selected_space = global.storage.selected_space;
                    if (selected_space === null) {
                        return;
                    }
                    return InputTextArea.interact({
                        tip: global.internationalization.text("archive.Archive-name"),
                        current_text: selected_space.name,
                        validators: {pattern: ".{1,32}"},
                        error_message: global.internationalization.text("archive.Archive-name-shall-be-filled")
                    }).then((name) => {
                        if (name === null) {
                            return;
                        }
                        log.info(`new space name ${name}`);
                        selected_space.name = name;
                        return selected_space.data_commit().then(() => {
                            refreshSpaceStatus(selected_space.index);
                            resolve(name);
                        });
                    });
                },
                duplicate: async () => {
                    var selected_space = global.storage.selected_space;
                    if (selected_space === null) {
                        return;
                    }
                    var new_space_index = await RoomListArea.interact({
                        title: global.internationalization.text("archive.Duplicate-to"),
                        selected_space: selected_space.index,
                        selected_disable: true,
                        ask_confirmation: true
                    });
                    if (new_space_index === null) {
                        return;
                    }
                    if (await global.storage.space_exists({space_index: new_space_index})) {
                        var selected_space_name = await global.storage.get_space_name({space_index: new_space_index});
                        if (selected_space_name === "") {
                            selected_space_name = global.internationalization.text("global.Without-name");
                        }
                        var confirmation = await ConfirmationArea.interact({
                            title: global.internationalization.text("global.Warning"),
                            tip1: global.internationalization.text("archive.Clean-and-replace-name", {name: selected_space_name})
                        });
                        if (!confirmation) {
                            return;
                        }
                    }

                    var space_name = await InputTextArea.interact({
                        tip: global.internationalization.text("archive.Archive-name"),
                        current_text: selected_space.name,
                        validators: {pattern: ".{1,32}"},
                        error_message: global.internationalization.text("archive.Archive-name-shall-be-filled")
                    });
                    if (space_name === null) {
                        return;
                    }

                    await global.storage.delete_space({space_index: new_space_index});
                    var duplicated = [];
                    for (let desktop_index = 0; desktop_index < selected_space.context_number; desktop_index++) {
                        let context = selected_space.context[desktop_index];
                        if (context === null) {
                            continue;
                        }
                        duplicated.push(
                            global.storage.duplicate({
                                space_index: selected_space.index,
                                desktop_index,
                                new_space_index,
                                new_desktop_index: desktop_index
                            })
                        );
                    }
                    for (let channel_index = 0; channel_index < LOCAL_CHANNEL_NUMBER; channel_index++) {
                        let channel = selected_space.channel[channel_index];
                        if (channel === null) {
                            continue;
                        }
                        duplicated.push(
                            global.storage.duplicate_channel({
                                space_index: selected_space.index,
                                channel_index,
                                new_space_index,
                                new_channel_index: channel_index
                            })
                        );
                    }
                    await Promise.all(duplicated);
                    await global.storage.open({space_index: new_space_index, desktop_index: 0});
                    global.storage.selected_space.name = space_name;
                    await global.storage.selected_space.data_commit();
                    refreshSpaceStatus(global.storage.selected_space.index);
                    refreshSelection();
                    resolve();
                },
                erase: async () => {
                    if (global.storage.selected_space === null) {
                        return;
                    }
                    var selected_space_name = global.storage.selected_space.name;
                    if (selected_space_name === "") {
                        selected_space_name = global.internationalization.text("global.Without-name");
                    }
                    let confirmation = await ConfirmationArea.interact({
                        title: global.internationalization.text("global.Warning"),
                        tip1: global.internationalization.text("archive.Clean-name", {name: selected_space_name})
                    });
                    if (!confirmation) {
                        return;
                    }
                    let space_index = global.storage.selected_space.index;
                    await global.storage.delete_space({});
                    await global.storage.open({space_index: space_index, desktop_index: 0});
                    refreshSpaceStatus(space_index);
                    resolve();
                },
                close: () => {
                    interaction_end();
                    resolve();
                },
                show_app_info: async () => {
                    LegalArea.interact();
                }
            };
            $("body").on("click.room_area.btn", "#room_area .btn", (event) => {
                let $btn = $(event.currentTarget);
                handlers[$btn.data("method")]($btn);
            });
            $("body").on("click.room_area.backdrop", "#room_area .modal-backdrop", () => {
                handlers["close"]();
            });
        });
    };
};

export default new RoomArea();
